export default __webpack_public_path__ + "static/media/stc820.0dcdbca4.jpg";